import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import NotFound from "@/pages/NotFound";
import { news } from "@/mocks/news";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function NewsDetail() {
  const { id } = useParams();
  const item = news.find((n) => n.id === id);

  useDocumentTitle(
    item ? `${item.title} - 芒果传媒动态` : "新闻详情 - 芒果传媒",
    item ? item.summary : undefined
  );

  if (!item) return <NotFound />;

  const related = news.filter((n) => n.id !== item.id && n.category === item.category).slice(0, 3);
  const fallbackRelated =
    related.length > 0 ? related : news.filter((n) => n.id !== item.id).slice(0, 3);

  return (
    <div className="bg-background-50">
      <section className="bg-secondary-50 pt-28 md:pt-32 pb-10 md:pb-12">
        <div className="container-site max-w-4xl">
          <Breadcrumb items={[{ label: "新闻动态", path: "/news" }, { label: item.title }]} />
          <div className="flex items-center gap-3 mt-6 text-xs md:text-sm">
            <span className="px-2.5 py-1 rounded bg-primary-100 text-primary-700 font-semibold">
              {item.category}
            </span>
            <span className="text-foreground-500 flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {item.date}
            </span>
          </div>
          <h1 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-4 leading-tight">
            {item.title}
          </h1>
        </div>
      </section>

      <article className="container-site max-w-4xl py-10 md:py-14">
        <div className="w-full aspect-[16/9] rounded-lg overflow-hidden mb-8">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 芒果传媒动态`}
            className="w-full h-full object-cover object-top"
          />
        </div>

        <p className="text-foreground-800 font-medium leading-relaxed text-base md:text-lg border-l-4 border-primary-500 pl-4">
          {item.summary}
        </p>

        <div className="flex flex-col gap-4 mt-6">
          {item.content.map((p, i) => (
            <p key={i} className="text-foreground-700 leading-relaxed text-sm md:text-base">
              {p}
            </p>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200">
          <Link
            to="/news"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            返回新闻列表
          </Link>
        </div>
      </article>

      <section className="bg-secondary-50 py-14 md:py-16">
        <div className="container-site max-w-4xl">
          <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950">
            相关新闻
          </h2>
          <div className="flex flex-col gap-4 mt-6">
            {fallbackRelated.map((n) => (
              <Link
                key={n.id}
                to={`/news/${n.id}`}
                className="group flex items-start justify-between gap-4 bg-background-50 rounded-lg p-5 border border-background-200/80 hover:border-primary-300 transition-all cursor-pointer"
              >
                <div>
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {n.title}
                  </h3>
                  <span className="text-xs text-foreground-500 mt-1.5 flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {n.date} · {n.category}
                  </span>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-700 transition-colors mt-1 shrink-0"></i>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}